<template>
  <div class="banner-create">
    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="100px">
      <el-form-item label="Banner名称" prop="grade" v-if="form.showType=='Banner'">
        <el-input v-model="form.name" placeholder="请输入Banner名称" class="input" />
      </el-form-item>
       <el-form-item label="弹窗名称" prop="grade" v-else>
        <el-input v-model="form.name" placeholder="请输入弹窗名称" class="input" />
      </el-form-item>
      <el-form-item label="商场" prop="selectedRange">
        <el-select v-model="form.selectedRange" placeholder="请选择商场" @change="onMallChange" multiple filterable collapse-tags>
          <el-option label="全部" value="ALL"></el-option>
          <el-option v-for="(item, index) in mallOption" :label="item.name" :value="item.id" :key="index" :disabled="form.selectedRange.indexOf('ALL') >= 0"></el-option>
        </el-select>
      </el-form-item>
       <el-form-item label="活动时间" prop="activityDate"  v-if="form.showType!='Banner'">
        <el-date-picker
          v-model="form.activityDate"
          type="datetimerange"
          range-separator=""
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="timestamp"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="序号" prop="sort">
        <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="form.sort" placeholder="请输入序号" class="input" />
      </el-form-item>
      <el-form-item label="图片" prop="image">
        <UploadImg @getUploadFile="(file)=>{ this.form.image = file }" :uploadUrl="form.image" :desc="form.showType=='Banner'? sizeDesc :'建议：上传254*300的jpg、 png的图片'"></UploadImg>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-radio-group v-model="form.type" @change="typeChange">
          <el-radio label="base">内部链接</el-radio>
          <el-radio label="out">外部链接</el-radio>
          <el-radio label="text">富文本</el-radio>
          <el-radio label="miniprogram">小程序跳转</el-radio>
          <auth-button auth="banner:popup" >
            <el-radio label="poster" v-if="form.showType=='Banner'">海报弹窗</el-radio>
          </auth-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="海报图片" prop="posterImg"  v-if="form.type=='poster'&&form.showType=='Banner'">
        <UploadImg @getUploadFile="(file)=>{ this.form.posterImg = file }" :uploadUrl="form.posterImg"  desc='建议：上传280*330的jpg、 png的图片'></UploadImg>
      </el-form-item>
      <el-form-item label="" prop="url" v-if="form.type=='out' || form.type=='base' || form.type=='poster' || form.type=='miniprogram'">
        <el-input v-model="form.url" placeholder="请输入跳转链接" class="input" >
            <template v-if="form.type=='out' || form.type=='poster'" slot="prepend" >Https://</template>
        </el-input>
      </el-form-item>
      <el-form-item label="" prop="appId" v-if="form.type=='miniprogram'">
          <el-input v-model="form.appId" placeholder="请输入appid" class="input"></el-input>
      </el-form-item>
        <el-form-item label="详情" prop="remark"  v-if="form.type=='text'">
        <div style="border: 1px solid #ccc; margin-top: 10px;width: calc(100% - 40px);">
          <!-- 工具栏 -->
          <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
          />

          <!-- 编辑器 -->
          <Editor
            style="height: 600px; overflow-y: hidden;"
            :defaultConfig="editorConfig"
            v-model="form.remark"
            @onCreated="onCreated"
          />
        </div>
      </el-form-item>
      <el-form-item label="状态" prop="enable">
        <el-radio-group v-model="form.enable">
          <el-radio :label="true">启用</el-radio>
          <el-radio :label="false">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="onBack" class="fun-btn mr20">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="onSubmit" class="fun-btn">确定</el-button>
    </div>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import UploadImg from '@/components/UploadImg/index'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import editor from '@/mixins/editor'
import { api_getBannerDetail, api_putUpdateBanner, api_postAddBanner, api_getSize } from '@/api/banner'
import { api_postFileUpload, api_getConfig } from '@/api/common'
export default {
  name: "mEquityCreate",
  components: {
    UploadImg,
    Editor,
    Toolbar,
    AuthButton
  },
  mixins: [editor],
  data() {
    return {
      id:null,
      form: {
        selectedRange: [],
        sort: '',
        image: '',
        url: '',
        name: '',
        enable: true,
        type:'base',
        showType:'',
        appId:''

      },
      mallOption: [],
      rules: {
        name: [{ required: true, message: '请输入名称' }],
        activityDate: [{ required: true, message: '请选择活动时间' }],
        selectedRange: [{ required: true, message: '请选择商场' }],
        sort: [{ required: true, message: '请输入序号' }],
        image: [{ required: true, message: '请上传图片' }],
        url: [{ required: true, message: '请输入跳转路径' }],
        appId: [{ required: true, message: '请输入appid' }],
      },
      submitLoading: false,
      sizeDesc: '建议：上传375*180的jpg、 png的图片'
    };
  },
  created() {
    if (this.$route.query.id) {
     this.id = this.$route.query.id
     this.$route.query.showType=='PopUp'?this.$route.meta.breadcrumbTitle = '<span class="noblack">服务配置/广告列表<span class="black">/编辑弹窗</span></span>':this.$route.meta.breadcrumbTitle = '<span class="noblack">服务配置/广告列表<span class="black">/编辑Banner</span></span>'
      this.getInfo()
    } else {
      this.$route.query.showType=='PopUp'?this.$route.meta.breadcrumbTitle = '<span class="noblack">服务配置/广告列表<span class="black">/创建弹窗</span></span>':this.$route.meta.breadcrumbTitle = '<span class="noblack">服务配置/广告列表<span class="black">/创建Banner</span></span>'
    }
    this.form.showType = this.$route.query.showType?this.$route.query.showType:''
    this.getConfigData()
    this.getSize()
  },
  methods: {
    async getSize() {
      let res= await api_getSize()
      this.sizeDesc = res.desc || '建议：上传375*180的jpg、 png的图片'
      console.log('line:141 res: ', res);
    },
    // 获取config数据（商场、店铺级联框）
    async getConfigData() {
      let {mall} = await api_getConfig(['mall'])
      mall.forEach(item => item.id = item.id + '')
      this.mallOption = mall
    },

    // 商场下拉框改变
    onMallChange(data) {
      if (data.indexOf('ALL') >= 0) {
        this.form.selectedRange = ['ALL']
      }
    },

    // 点击提交按钮
    onSubmit() {
      if (this.form.detail == "<p><br></p>") {
        this.form.detail = "";
      }
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          let { activityDate, selectedRange } = this.form
          let mallName = this.mallOption.filter(item => selectedRange.includes(item.id))

          let params = {
            ...this.form,
            showStartTime: activityDate && activityDate[0] ? activityDate[0] : null,
            showEndTime: activityDate && activityDate[1] ? activityDate[1] : null,
            selectedRange: selectedRange.join(','),
            mallName: selectedRange.indexOf('ALL') >= 0 ? '全部' : (mallName.map(item => item.name)).join(',')
          }
          delete params.activityDate
          try {
            if (this.form.image&&this.form.image.size) {
              const { key } = await api_postFileUpload(this.form.image, 'BannerLogo')
              params.image = key
            }
            if (this.form.posterImg&&this.form.posterImg.size) {
              const { key } = await api_postFileUpload(this.form.posterImg, 'BannerLogo')
              params.posterImg = key
            }
            switch (params.type) {
              case 'out':
              case 'base':
                delete params.remark
                delete params.appId
                delete params.posterImg
              break;
              case 'text':
                delete params.url
                delete params.appId
                delete params.posterImg
              break;
              case 'miniprogram':
                delete params.remark
                delete params.posterImg
              break;
              case 'poster':
                delete params.remark
                delete params.appId
              break;
              default:
                break;
            }

             //0禁用，1启用
            params.enable ? params.enable = 1 : params.enable = 0
              if ((params.type == 'out' || params.type == 'poster') && !params.url.startsWith("https://") ) {
                params.url = `https://${params.url}`
              }else{
                params.url
              }
            this.$route.query.id ? await api_putUpdateBanner({...params, id: this.$route.query.id}) : await api_postAddBanner(params)
            this.$baseMessage('操作成功', 'success')
            this.onBack()
            this.submitLoading = false
          } catch {
            this.submitLoading = false
          }
        }
      })
    },
     // 字符串截取
    sliceString(str, prefix) {
      if (str.indexOf(prefix) === 0) {
        return str.slice(prefix.length);
      }
      return str;
    },
    typeChange(){
      this.form.url = ''
      this.form.appId = ''
      this.form.remark = ''
      this.form.posterImg = ''
      this.$refs.form.clearValidate();
      this.$forceUpdate()

    },
    // 获取详情数据
    async getInfo () {
      const data = await api_getBannerDetail({id: this.$route.query.id})
      let {name, selectedRange, sort, image, enable, url, type, showType, remark,appId,posterImg} = data
      let activityDate = [data.showStartTime, data.showEndTime]
      selectedRange = selectedRange ? selectedRange.split(',') : []
      enable === 1?enable=true:enable=false
      url = url?this.sliceString(url,'https://'):''
      appId = appId?appId:''
      this.form = {name, selectedRange, sort, image, enable, url, type, activityDate, showType, remark,appId,posterImg}
    },
    // 返回
    onBack() {
      if(this.form.showType == 'PopUp'){
         this.$router.push(`/serverConfig/bannerList?tabsKey=1`)
        console.log('1')
      }else{
          this.$router.push(`/serverConfig/bannerList`)
      }

    },
  },
};
</script>

<style lang="scss" scoped>
.banner-create {
  width: 100%;
  padding-top: 20px;
  box-sizing: border-box;
  position: relative;
  padding-bottom: 100px;
  .el-input,
  .el-textarea,
  .el-select {
    width: 350px;
  }

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
    position: absolute;
    left: 350px;
    bottom: 0;
  }

  .optional {
    height: 17px;
    line-height: 17px;
    margin-top: 5px;
    font-size: 12px;
    color: #666666;
  }
  ::v-deep{
    .avatar-uploader{
      height: 152px;
    }
  }

  .footer{
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
  }
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
